<template>
	<section id="testimonials" class="sg-section">
		<v-container style="position: relative;">
			<h2 class="sg-section-title">{{ content.title }}</h2>
			<div class="sg-gold-line"></div>
			<p class="sg-section-subtitle">تجربه خرید مشتریان ما</p>

			<v-carousel
				hide-delimiter-background
				delimiter-icon="mdi-minus"
				:height="320"
				show-arrows
				cycle
			>
				<v-carousel-item v-for="(group, i) in groupedItems" :key="i">
					<v-row class="pa-4">
						<v-col v-for="(item, j) in group" :key="j" cols="12" md="6">
							<div class="sg-testimonial-card">
								<div class="d-flex align-center mb-3">
									<v-avatar color="#FFF9F0" size="48" class="ml-3">
										<v-icon color="#C9A227">mdi-account</v-icon>
									</v-avatar>
									<div>
										<div class="font-weight-bold">{{ item.name }}</div>
										<div class="d-flex">
											<v-icon v-for="s in 5" :key="s" x-small color="#C9A227">mdi-star</v-icon>
										</div>
									</div>
								</div>
								<p class="grey--text text--darken-1 mb-0 text-justify" style="line-height: 1.8; font-size: 0.9rem;">
									{{ item.comment }}
								</p>
							</div>
						</v-col>
					</v-row>
				</v-carousel-item>
			</v-carousel>

			<div v-if="editable" style="position: absolute; top: 0; left: 0;">
				<v-btn small outlined color="primary" @click="edit()">ویرایش</v-btn>
			</div>
		</v-container>

		<v-dialog v-model="settingsDialog" persistent max-width="600px">
			<v-card>
				<v-card-title>ویرایش نظرات مشتریان</v-card-title>
				<v-card-text>
					<v-text-field v-model="settings.title" label="عنوان" outlined dense />
					<v-card v-for="(item, idx) in settings.comments" :key="idx" outlined class="mb-3 pa-3">
						<v-text-field v-model="item.name" label="نام" dense outlined />
						<v-textarea v-model="item.comment" label="نظر" dense outlined rows="2" />
						<v-btn x-small text color="red" @click="settings.comments.splice(idx, 1)">حذف</v-btn>
					</v-card>
					<v-btn small color="primary" @click="settings.comments.push({ name: '', comment: '' })">افزودن نظر</v-btn>
				</v-card-text>
				<v-card-actions>
					<v-spacer />
					<v-btn text @click="settingsDialog = false">بستن</v-btn>
					<v-btn color="primary" :loading="submitEditLoading" @click="submitEdit">ذخیره</v-btn>
				</v-card-actions>
			</v-card>
		</v-dialog>
	</section>
</template>

<script>
	import { cloneDeep } from 'lodash'
	import { get } from 'vuex-pathify'
	import api from '@/util/app-api'
	import { emptyId } from '@/util/emptyId'
	import toast from '@/util/toast'

	export default {
		name: 'TestimonialsSection',
		props: {
			data: { type: Object },
			contentKey: { type: String },
			editable: { type: Boolean },
		},
		data: () => ({
			localData: null,
			settings: {},
			settingsDialog: false,
			submitEditLoading: false,
		}),
		computed: {
			...get('siteConfig', ['customerCode']),
			content() {
				return this.localData?.content || this.defaultContent()
			},
			ccode() {
				return this.customerCode || this.$route.params.customerCode || 0
			},
			groupedItems() {
				const comments = this.content.comments || []
				const groups = []
				for (let i = 0; i < comments.length; i += 2) {
					groups.push(comments.slice(i, i + 2))
				}
				return groups.length ? groups : [[]]
			},
		},
		mounted() {
			if (this.data) {
				this.localData = {
					id: this.data.id,
					key: this.data.key,
					isJson: this.data.isJson,
					content: JSON.parse(this.data.content),
				}
			} else {
				this.localData = {
					id: emptyId,
					key: this.contentKey,
					isJson: true,
					content: this.defaultContent(),
				}
			}
		},
		methods: {
			defaultContent() {
				return {
					title: 'تجربه خرید مشتریان',
					comments: [
						{ name: 'مریم احمدی', comment: 'خرید گردنبند طلا از طلای سیف زاده تجربه فوق‌العاده‌ای بود. کیفیت عالی و ارسال سریع. حتماً دوباره خرید می‌کنم.' },
						{ name: 'علی رضایی', comment: 'برای خرید قسطی طلا بهترین گزینه بود. فرآیند ساده و شفاف بود و فاکتور معتبر دریافت کردم.' },
						{ name: 'زهرا محمدی', comment: 'ست طلای عروسم را سفارشی ساختند و دقیقاً مطابق خواسته‌ام تحویل دادند. از اصالت طلا و ضمانتشان راضی‌ام.' },
						{ name: 'حسین کریمی', comment: 'قیمت‌ها منصفانه و شفاف است. امکان تعویض هم خیالم را راحت کرد. به همه توصیه می‌کنم.' },
					],
				}
			},
			edit() {
				this.settings = cloneDeep(this.content)
				this.settingsDialog = true
			},
			submitEdit() {
				this.submitEditLoading = true
				const data = cloneDeep(this.localData)
				data.content = JSON.stringify(this.settings)
				api.post('admin/SiteContent/CreateUpdate', data)
					.then(() => {
						this.localData.content = cloneDeep(this.settings)
						toast.success('اطلاعات با موفقیت ذخیره شد.')
						this.settingsDialog = false
					})
					.catch(err => toast.error(err.message))
					.finally(() => { this.submitEditLoading = false })
			},
		},
	}
</script>
